import * as React from 'react';
import FormRow from '../../../../../../components/FormRow';
import FormSection from '../../../../../../components/FormSection';
import InputHandler from '../../../../../../components/InputHandler';
import { IFormContext, withFormContext } from '../../../../../../containers/FormContextHandler';

const UHDRSForm = ({
  formData,
  editing,
  fm = (): string => '',
}: IFormContext<IUHDRSDiagnosticConfidenceIndex, IUHDRSDiagnosticConfidenceIndex>): React.JSX.Element => (
  <FormSection>
    <FormRow title="diagnosis.huntington.uhdrs.form.date">
      <InputHandler
        type="PartialDate"
        name="date"
        editing={!!editing}
        formData={formData}
        dateDefault="now"
        isNotCancellable={true}
      />
    </FormRow>
    <FormRow title="diagnosis.huntington.uhdrs.form.index">
      <React.Fragment>
        <InputHandler
          type="Radio"
          name="index"
          editing={!!editing}
          formData={formData}
          options={['0', '1', '2', '3', '4']}
          optionFormatter={(name: string | number): string | React.JSX.Element => {
            if (editing) {
              return `${name} - ` + fm(`diagnosis.huntington.uhdrs.form.opts.${name}`);
            } else {
              return fm(`diagnosis.huntington.uhdrs.form.opts.${name}`);
            }
          }}
        />
      </React.Fragment>
    </FormRow>
  </FormSection>
);

export default withFormContext(UHDRSForm);
